import React from "react"

import { Box, Headline, SubHeadline } from "@theguarantors/ui-kit-v2/dist/design-system/typography"
import { AddressForm } from "./AddressForm.form"
import { FeatureFlag, useFeatureFlag } from "../../../../hooks/use-feature-flag"
import { colors } from "@theguarantors/ui-kit-v2/dist/design-system/colors"
import { BodyCopyMedium } from "@theguarantors/ui-kit-v2"

export const AddressFormComponent: React.FC = () => {
  const [rebrandV2MonolithReact] = useFeatureFlag(FeatureFlag.REBRAND_V2_MONOLITH_REACT)

  const rebrandV2MonolithReactFeatureFlag: Boolean = rebrandV2MonolithReact === "on"

  const [newGetStartedPage] = useFeatureFlag(FeatureFlag.NEW_GET_STARTED_PAGE)
  const newGetStartedPageFeatureFlag: boolean = newGetStartedPage === "on"

  if (newGetStartedPageFeatureFlag) {
    return (
      <Box>
        <Box
          display="flex"
          alignItems={["left", "left", "center"]}
          flexDirection="column"
          textAlign={["left", "left", "center"]}
          mt="80px"
        >
          <Headline fontFamily="ivar" color={colors.v2_black} fontWeight="400" margin="0" size="xl">
            Found your dream apartment? <br />
            Get qualified now.
          </Headline>
          <BodyCopyMedium fontFamily="acid" color={colors.v2_black} fontWeight="400" margin="32px 0 54px" size="s">
            Apply for Rent and Deposit Coverage by searching for your building below.
          </BodyCopyMedium>
        </Box>
        <Box
          display="flex"
          m="0 auto"
          borderRadius="1rem"
          position="relative"
          zIndex={3}
          bg="white"
          padding="2.4rem 0"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          minHeight="37rem"
          boxShadow="0 2.2rem 2.4rem 0 rgba(148, 169, 200, 0.31)"
          width={["100%", "85%", "70%"]}
        >
          <AddressForm />
        </Box>
      </Box>
    )
  }

  return (
    <Box minHeight="70vh">
      <Box
        display="flex"
        alignItems={["left", "left", "center"]}
        flexDirection="column"
        textAlign={["left", "left", "center"]}
      >
        <Headline color={rebrandV2MonolithReactFeatureFlag ? "violet" : "white"}>
          Get qualified quickly for your next apartment.
        </Headline>
        <SubHeadline size="m" pb="2rem" color={rebrandV2MonolithReactFeatureFlag ? "violet" : "white"}>
          We believe there shouldn't be limits on finding the ideal space to live. <br />
          Our Dynamic Lease Guarantee can help!
        </SubHeadline>
      </Box>
      <Box
        display="flex"
        m="0 auto"
        borderRadius="1rem"
        position="relative"
        zIndex={3}
        bg="white"
        padding="2.4rem 0"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        minHeight="37rem"
        boxShadow="0 2.2rem 2.4rem 0 rgba(148, 169, 200, 0.31)"
        width={["100%", "85%", "70%"]}
      >
        <AddressForm />
      </Box>
    </Box>
  )
}
